import { TextLink } from "nystem-components";

const TextareaLink = (props) => <TextLink {...props} />;
export default TextareaLink;
